import type { CustomerStory, Faq } from "../../types/listingModels";
import type { ExpertListingCustomerStoryRequest, ExpertListingFaqRequest } from "@shopexperts/shared";

/**
 * Transforms case studies to reorder-only API format
 */
export function transformCustomerStoriesToApi(
    stories: CustomerStory[]
): ExpertListingCustomerStoryRequest[] {
    return stories
        .filter((story): story is CustomerStory & { id: number } => story.id != null)
        .map((story) => ({
            id: Number(story.id),
        }));
}

/**
 * Transforms FAQs to API format
 * Pure function - just handles nullable ID conversion
 */
export function transformFaqsToApi(faqs: Faq[]): ExpertListingFaqRequest[] {
    return faqs.map((f) => ({
        id: f.id != null ? Number(f.id) : undefined,
        question: f.question,
        answer: f.answer,
    }));
}
